export default {
  // Get templates by type
  getTemplatesByType: state => templateType => {
    return state.templates[templateType] || []
  },

  // Get formatted template options for dropdowns
  getTemplateOptions: state => templateType => {
    const templates = state.templates[templateType] || []
    return templates.map(template => ({
      text: template.title || template.name || `Template ${template.id}`,
      value: template.id,
    }))
  },

  // Get templates filtered by category
  getTemplatesByCategory: state => (templateType, category) => {
    const templates = state.templates[templateType] || []
    if (!category) return templates
    return templates.filter(template => template.category === category)
  },

  // Get loading state by type
  isLoadingByType: state => templateType => {
    return state.loading[templateType] || false
  },

  // Get language options for dropdowns
  languageOptions: state => {
    return state.languages.map(language => ({
      text: language.name,
      value: language.id,
    }))
  },

  // Get template by id and type
  getTemplateById: state => (templateType, templateId) => {
    const templates = state.templates[templateType] || []
    return templates.find(template => template.id === templateId)
  },

  // Check if languages are loading
  isLanguagesLoading: state => state.languagesLoading,
}
